/**
 * StickyDirective class handles the sticky behavior of elements within a container.
 * It adjusts the margin-top of the selected element based on the scroll position and the height of other elements.
 */
class StickyDirective {
    /**
     * Constructor for StickyDirective.
     * @param {Object} $interval - AngularJS $interval service.
     * @param {Object} $window - AngularJS $window service.
     * @param {Object} SheetLoadedService - Service that provides a promise when the sheet is loaded.
     */
    constructor($interval, $window, SheetLoadedService) {
        this.$interval = $interval;
        this.$window = $window;
        this.SheetLoadedService = SheetLoadedService;
    }

    /**
     * Link function to initialize the directive.
     * @param {Object} scope - AngularJS scope.
     * @param {Object} element - jQuery element.
     * @param {Object} attrs - Attributes of the directive.
     */
    link(scope, element, attrs) {
        // Return false if the sticky attribute is not defined or set to false
        if (!angular.isDefined(attrs.sticky) || attrs.sticky === 'false') {
            return false;
        }

        let _stickyIntervalCounter = 0;
        let _numberOfSmallChanges = 0;
        let onScrollDebounced;

        /**
         * Initializes the sticky behavior.
         */
        const _init = () => {
            let colLeft = element.find('.col-left');
            let colRight = element.find('.col-right');

            let selected;
            let theOtherOne;

            let scrollTop = 0;
            let initialOffsetTop;
            let selectedHeight = 0;
            let theOtherOneHeight = 0;
            let marginTop = 0;

            const defaultMarginTop = 20;

            const navHeight = $('div.navbar-fixed-top').height() + defaultMarginTop;

            /**
             * Handles the scroll event to adjust the margin-top of the selected element.
             */
            const onScroll = () => {
                scrollTop = angular.element(this.$window).scrollTop();

                selected = colLeft;
                theOtherOne = colRight;
                if (colLeft.outerHeight() > colRight.outerHeight()) {
                    selected = colRight;
                    theOtherOne = colLeft;
                }

                initialOffsetTop = theOtherOne.offset().top;
                selectedHeight = selected.outerHeight();
                theOtherOneHeight = theOtherOne.outerHeight();

                let oldMarginTop = parseInt(selected.css('marginTop'));

                if (scrollTop > initialOffsetTop) {
                    marginTop = scrollTop - initialOffsetTop + navHeight;
                    
                    if (marginTop + selectedHeight > theOtherOneHeight) {
                        marginTop = theOtherOneHeight - selectedHeight;
                    }
                    marginTop = Math.floor(marginTop);
                    let deltaMarginTop = Math.abs(oldMarginTop-marginTop);

                    if (deltaMarginTop == 0) {
                        return;
                    }

                    if (deltaMarginTop < 3) {
                        _numberOfSmallChanges++;
                    } else {
                        _numberOfSmallChanges=0;
                    }

                    if (_numberOfSmallChanges < 5) {
                        selected.css({
                            marginTop: marginTop
                        });
                    }

                } else {
                    if (oldMarginTop !== 0) {
                        selected.css({
                            marginTop: 0
                        });
                    }
                }
            };

            onScrollDebounced = _.debounce(onScroll, 33);

            angular.element(this.$window).on('scroll', onScrollDebounced);
        };

        this.SheetLoadedService.getPromise().then(() => {
            let _stickyInterval = this.$interval(() => {
                if (_stickyIntervalCounter > 20) {
                    this.$interval.cancel(_stickyInterval);
                }

                let colLeft = element.find('.col-left');
                let colRight = element.find('.col-right');

                if (colLeft.length > 0 && colRight.length > 0) {
                    this.$interval.cancel(_stickyInterval);
                    _init();
                }
                _stickyIntervalCounter++;
            }, 500);
        });

        scope.$on('$destroy', () => {
            if (onScrollDebounced) {
                angular.element(this.$window).off('scroll', onScrollDebounced);
            }
        });
    }
}

export default StickyDirective;